export const WORKOUTS_UI_RU = {
  'workout.suggestAddToDict': '+ Добавить "{name}" в словарь',

  'workout.classic.bench': 'Жим штанги лёжа',
  'workout.classic.squatBarbell': 'Приседания со штангой',
  'workout.classic.deadlift': 'Становая тяга',
  'workout.classic.ohp': 'Жим штанги стоя',
  'workout.classic.pullUps': 'Подтягивания',
  'workout.classic.pushUps': 'Отжимания',
  'workout.classic.squats': 'Приседания',
  'workout.classic.lunges': 'Выпады',
  'workout.classic.latPulldown': 'Тяга верхнего блока',
  'workout.classic.dbRow': 'Тяга гантели в наклоне',
  'workout.classic.latRaise': 'Разведение гантелей в стороны',
  'workout.classic.barbellCurl': 'Сгибания рук со штангой',
  'workout.classic.tricepPushdown': 'Разгибания рук на блоке',
  'workout.classic.calfRaise': 'Подъемы на носки',
  'workout.classic.crunches': 'Скручивания',
  'workout.classic.plank': 'Планка',
  'workout.classic.burpee': 'Бёрпи',
  'workout.classic.other': 'Другие',

  'workout.err.historyLoad': 'Не удалось загрузить историю упражнения',
  'workout.err.gymNameRequired': 'Укажите название зала',
  'workout.err.trainerForLocation': 'Не удалось определить тренера для добавления локации',
  'workout.err.createdGymId': 'Не удалось получить ID созданного зала',
  'workout.toast.gymAdded': 'Зал успешно добавлен',
  'workout.err.gymAddFailed': 'Не удалось добавить зал. Попробуйте ещё раз.',
  'workout.confirm.deleteWorkoutSimple': 'Вы уверены, что хотите удалить эту тренировку?',
  'workout.err.deleteWorkoutFailed': 'Не удалось удалить тренировку',
  'workout.toast.recurrenceDuplicateSlot': 'Этот день недели и время уже выбраны',
  'workout.err.clientWorkoutNotFound': 'Не удалось найти тренировку этого клиента на выбранное время',
  'workout.err.openClientWorkoutNoHandler': 'Не удалось открыть тренировку клиента (нет обработчика)',
  'workout.err.openClientWorkout': 'Не удалось открыть тренировку клиента',
  'workout.err.groupExerciseTargets': 'Не удалось определить тренировки участников для добавления упражнения',
  'workout.toast.exerciseAddedPartial': 'Добавлено не всем участникам: {ok}/{total}',
  'workout.toast.exerciseAddedAll': 'Упражнение добавлено всем участникам ({n})',
  'workout.alert.pickExerciseName': 'Выберите или введите название упражнения',
  'workout.alert.setRepsInvalid': 'Подход {n}: Введите корректное количество повторений (только целые числа)',
  'workout.alert.setWeightInvalid': 'Подход {n}: Введите корректный вес (число с запятой или точкой, или оставьте пустым)',
  'workout.success.exerciseAdded': 'Упражнение успешно добавлено!',
  'workout.err.exerciseAdd': 'Ошибка при добавлении упражнения',
  'workout.alert.planNoExercises': 'В этом плане нет упражнений',
  'workout.err.participantWorkoutsPlan': 'Не удалось определить тренировки участников для добавления плана',
  'workout.success.planExercisesAdded': 'Добавлено {n} упражнений из плана «{name}»',
  'workout.err.planExercisesAdd': 'Ошибка при добавлении упражнений из плана',
  'workout.alert.planExercisesAllDuplicate': 'Все упражнения из плана уже добавлены в эту тренировку',
  'workout.success.planExercisesAddedCount': 'Добавлено {n} упражнений из плана «{name}»',
  'workout.alert.planExercisesAddFail': 'Не удалось добавить упражнения из плана. Проверьте соединение или повторите попытку.',
  'workout.alert.planExercisesAllDup2': 'Все упражнения из плана уже были добавлены.',
  'workout.err.unknown': 'Неизвестная ошибка',
  'workout.err.planExercisesWithMsg': 'Ошибка при добавлении упражнений из плана: {msg}',
  'workout.confirm.replacePlanExercises': 'Заменить все существующие упражнения упражнениями из выбранного плана?',
  'workout.err.deleteExistingExercises': 'Ошибка при удалении существующих упражнений',
  'workout.success.addedNExercises': 'Добавлено {n} упражнений',
  'workout.err.addExercisesBulk': 'Ошибка при добавлении упражнений',
  'workout.alert.enterExerciseName': 'Введите название упражнения',
  'workout.alert.duplicateExerciseInWorkout': 'Упражнение с таким названием уже есть в этой тренировке',
  'workout.success.exerciseUpdated': 'Упражнение успешно обновлено!',
  'workout.err.exerciseUpdate': 'Ошибка при обновлении упражнения',
  'workout.err.exerciseDelete': 'Ошибка при удалении упражнения',
  'workout.err.cancelSeriesNoClient': 'Невозможно отменить серию: тренировка без клиента',
  'workout.toast.cancelledN': 'Отменено {n} тренировок',
  'workout.toast.workoutCancelled': 'Тренировка отменена',
  'workout.err.cancelFailedN': 'Не удалось отменить {n} тренировок',
  'workout.err.cancelNoConfirm': 'Не удалось отменить тренировку. Ответ сервера не содержит подтверждения.',
  'workout.err.cancelWorkout': 'Ошибка при отмене тренировки',
  'workout.err.withMessage': 'Ошибка: {msg}',
  'workout.err.markSkipped': 'Не удалось отметить как пропуск',
  'workout.err.skipMark': 'Ошибка при отметке как пропуск',
  'workout.err.restoreWorkout': 'Ошибка при восстановлении тренировки',
  'workout.success.commentSaved': 'Комментарий сохранен',
  'workout.success.commentRemoved': 'Комментарий удален',
  'workout.err.commentSave': 'Ошибка при сохранении комментария',
  'workout.err.locationUpdate': 'Не удалось обновить локацию',
  'workout.err.locationDelete': 'Ошибка при удалении локации',
  'workout.err.commentDelete': 'Ошибка при удалении комментария',
  'workout.alert.fillDateTime': 'Заполните дату и время',
  'workout.err.transferNoConfirm': 'Не удалось перенести тренировку. Ответ сервера не содержит подтверждения.',
  'workout.alert.timeBusy': 'Данное время занято. Конфликт с тренировками: {clients}',
  'workout.alert.otherWorkouts': 'другими тренировками',
  'workout.alert.sameClientConflict': 'У клиента уже есть тренировка в это время',
  'workout.err.transferHttp': 'Ошибка при переносе тренировки: {status}',
  'workout.err.transferNetwork': 'Ошибка сети при переносе тренировки. Проверьте подключение к серверу.',

  'workout.detail.meetingDetails': 'Детали встречи',
  'workout.detail.badgeTransferred': 'Перенесено',
  'workout.detail.badgeSkipped': 'Пропуск',
  'workout.detail.editingTitle': 'Редактирование',
  'workout.title.pickClient': 'Выбрать клиента',
  'workout.title.openClientProfile': 'Открыть профиль клиента',
  'workout.field.dateTime': 'Дата и время',
  'workout.editDateTimeTitle': 'Редактировать дату и время',
  'workout.location.gymNameLabel': 'Название зала *',
  'workout.location.gymNamePh': 'Введите название зала',
  'workout.location.gymAddressLabel': 'Адрес зала',
  'workout.location.gymAddressPh': 'Введите адрес зала',
  'workout.location.notSetOption': 'Не указано',
  'workout.location.addNewGym': '+ Добавить новый зал',
  'workout.location.sectionTitle': 'Локация',
  'workout.location.pinOnline': '📍 Онлайн',
  'workout.editLocationTitle': 'Редактировать локацию',
  'workout.removeLocationTitle': 'Удалить локацию',
  'workout.removeLocationDesc': 'Вы уверены, что хотите удалить локацию этой тренировки? Это действие нельзя отменить.',
  'workout.addLocationTitle': 'Добавить локацию',
  'workout.comment.fullLabel': 'Комментарий к данной тренировке',
  'workout.comment.shortLabel': 'Комментарий',
  'workout.editCommentTitle': 'Редактировать комментарий',
  'workout.deleteCommentTitle': 'Удалить комментарий',
  'workout.deleteCommentDesc': 'Вы уверены, что хотите удалить этот комментарий? Это действие нельзя отменить.',
  'workout.commentPlaceholder': 'Введите комментарий...',
  'workout.previousWorkout': 'Предыдущая тренировка',
  'workout.prevWorkoutNavTitle': 'Предыдущая тренировка (раньше по времени)',
  'workout.nextWorkoutNavTitle': 'Следующая тренировка (позже по времени)',
  'workout.exerciseHistoryTitle': 'История упражнения',
  'workout.lastSession': 'Последняя тренировка',
  'workout.workingWeight': 'Рабочий вес',
  'workout.noHistoryData': 'Нет данных',
  'workout.duplicateExerciseTitle': 'Упражнение уже добавлено',
  'workout.duplicateExerciseDesc': 'Упражнение «{name}» уже есть в этой тренировке.',
  'workout.setsLabel': 'Подходы',
  'workout.noSetsTitle': 'Нет добавленных подходов',
  'workout.noSetsHint': 'Добавьте первый подход, чтобы начать',
  'workout.addFirstSet': 'Добавить первый подход',
  'workout.focusRepsTitle': 'Фокус на поле повторений',
  'workout.focusWeightTitle': 'Фокус на поле веса',
  'workout.weightInputShort': 'Вес',
  'workout.addAnotherSet': 'Добавить еще подход',
  'workout.form.editExercise': 'Редактировать упражнение',
  'workout.form.addExercise': 'Добавить упражнение',
  'workout.exerciseNameLabel': 'Название упражнения',
  'workout.tapToPickExercise': 'Нажмите, чтобы выбрать упражнение',
  'workout.searchExercisesShort': 'Поиск упражнений...',
  'workout.historyGroupOnly': 'История упражнения доступна только для индивидуальных тренировок',
  'workout.historyNoClient': 'Нет клиента у тренировки — историю упражнения показать нельзя',
  'workout.setLine': 'Подход {n}: {reps} повторений',
  'workout.setWeightPart': ' × {w} кг',
  'workout.noPrevWorkoutData': 'Нет данных за пред тренировку',
  'workout.exercisesHeading': 'Упражнения',
  'workout.planLabel': 'План:',
  'workout.unknownPlan': 'Неизвестный план',
  'workout.replacePlan': 'Заменить план',
  'workout.replaceShort': 'Заменить',
  'workout.addExerciseFull': 'Добавить упражнение',
  'workout.addPlan': 'Добавить план',
  'workout.planShort': 'План',
  'workout.or': 'или',
  'workout.addReadyMadePlan': 'Добавить готовый план',
  'workout.pickTrainingPlan': 'Выберите план тренировки',
  'workout.noPlansAvailable': 'Нет доступных планов тренировок',
  'workout.noExercisesInPlanCard': 'Нет упражнений',
  'workout.noExercises': 'Нет упражнений',
  'workout.editExerciseTitle': 'Редактировать упражнение',
  'workout.deleteExerciseTitle': 'Удалить упражнение',
  'workout.deleteExerciseConfirmTitle': 'Вы уверены?',
  'workout.deleteExerciseConfirmDesc': 'Это действие нельзя отменить. Упражнение будет удалено из тренировки.',
  'workout.workingWeightColon': 'Рабочий вес:',
  'workout.workingWeightGroupAlert': 'Рабочий вес можно обновлять только для индивидуальной тренировки с клиентом',
  'workout.updateWorkingWeightTitle': 'Обновить рабочий вес',
  'workout.updateWeightBtn': 'Обновить вес',
  'workout.workingWeightKgLabel': 'Рабочий вес (кг)',
  'workout.weightExamplePh': 'Например, 40',
  'workout.err.noWorkoutClient': 'Нет клиента у тренировки',
  'workout.err.workingWeightUpdate': 'Ошибка при обновлении рабочего веса',
  'workout.restoreSession': 'Восстановить занятие',
  'workout.movedSession': 'Тренировка перенесена',
  'workout.cancelSession': 'Отменить',
  'workout.markSkipBtn': 'Отметить как пропуск',
  'workout.markDoneBtn': 'Отметить как выполненную',
  'workout.markDoneTitle': 'Отметить как выполненную',
  'workout.markDoneDesc': 'Тренировка будет отмечена как завершённая.',
  'workout.toast.markedDone': 'Тренировка отмечена как выполненная',
  'workout.statusMenuAria': 'Изменить статус тренировки',
  'workout.err.statusUpdate': 'Не удалось обновить статус тренировки',
  'workout.rescheduleTitle': 'Перенести тренировку',
  'workout.rescheduleMoving': 'Перенос...',
  'workout.rescheduleValidating': 'Проверка...',
  'workout.rescheduleSubmit': 'Перенести',
  'workout.rescheduleHint': 'Выберите новую дату и время для тренировки',
  'workout.conflictTitle': 'Не получилось создать тренировку',
  'workout.conflictTimeTaken': 'К сожалению, данное время уже занято.',
  'workout.conflictingListTitle': 'Пересекающиеся тренировки:',
  'workout.clientNotSpecified': 'Клиент не указан',
  'workout.sameSlotTitle': 'Выберите новое время тренировки',
  'workout.sameSlotDesc': 'Дата и время совпадают с текущей тренировкой. Укажите другое время для переноса.',
  'workout.newDateLabel': 'Новая дата *',
  'workout.startTimeLabel': 'Время начала *',
  'workout.endTimeLabel': 'Время окончания',
  'workout.endTimePh': 'Как у исходной тренировки',
  'workout.durationHint': 'При смене времени начала длительность совпадает с текущей тренировкой',
  'workout.exerciseConfirmTitle': 'Добавить новое упражнение',
  'workout.exerciseConfirmDesc': 'Упражнение «{name}» не найдено в словаре. Хотите добавить его в ваш словарь упражнений?',
  'workout.muscleGroupLabel': 'Группа мышц',
  'workout.muscleGroupPh': 'Выберите группу мышц',
  'workout.dictTrainerNote': 'Упражнение будет добавлено в словарь текущего тренера',
  'workout.pickClientHeader': 'Выберите клиента',
  'workout.openingClientWorkout': 'Открываем тренировку…',
  'workout.willOpenClientWorkout': 'Откроется тренировка выбранного клиента',
  'workout.restoreTitle': 'Восстановить тренировку',
  'workout.restoreDesc': 'Тренировка будет восстановлена и получит статус «Запланирована».',
  'workout.restoring': 'Восстанавливаем...',
  'workout.restore': 'Восстановить',
  'workout.cancelWorkoutTitle': 'Отменить тренировку',
  'workout.cancelThisWorkout': 'Отменить данную тренировку',
  'workout.cancelFutureWorkouts': 'Отменить все последующие тренировки',
  'workout.cancelling': 'Отменяем...',
  'workout.back': 'Назад',
  'workout.skipTitle': 'Отметить как пропуск',
  'workout.skipDesc': 'Отметить эту тренировку как пропуск? Списание произойдёт как за завершённую.',
  'workout.markingSkip': 'Отмечаем...',
  'workout.addToDictButton': 'Добавить «{name}»',
  'workout.conflictOverlapFallback': 'Время пересекается с другими тренировками',
};

export const WORKOUTS_UI_EN = {
  'workout.suggestAddToDict': '+ Add "{name}" to dictionary',

  'workout.classic.bench': 'Barbell bench press',
  'workout.classic.squatBarbell': 'Barbell squat',
  'workout.classic.deadlift': 'Deadlift',
  'workout.classic.ohp': 'Barbell overhead press',
  'workout.classic.pullUps': 'Pull-ups',
  'workout.classic.pushUps': 'Push-ups',
  'workout.classic.squats': 'Squats',
  'workout.classic.lunges': 'Lunges',
  'workout.classic.latPulldown': 'Lat pulldown',
  'workout.classic.dbRow': 'Dumbbell row',
  'workout.classic.latRaise': 'Lateral raises',
  'workout.classic.barbellCurl': 'Barbell curl',
  'workout.classic.tricepPushdown': 'Tricep pushdown',
  'workout.classic.calfRaise': 'Calf raises',
  'workout.classic.crunches': 'Crunches',
  'workout.classic.plank': 'Plank',
  'workout.classic.burpee': 'Burpee',
  'workout.classic.other': 'Other',

  'workout.err.historyLoad': 'Couldn’t load exercise history',
  'workout.err.gymNameRequired': 'Enter the gym name',
  'workout.err.trainerForLocation': 'Couldn’t resolve trainer to add location',
  'workout.err.createdGymId': 'Couldn’t get ID of the new gym',
  'workout.toast.gymAdded': 'Gym added',
  'workout.err.gymAddFailed': 'Couldn’t add gym. Try again.',
  'workout.confirm.deleteWorkoutSimple': 'Delete this workout?',
  'workout.err.deleteWorkoutFailed': 'Couldn’t delete workout',
  'workout.toast.recurrenceDuplicateSlot': 'This weekday and time are already selected',
  'workout.err.clientWorkoutNotFound': 'No workout for this client at the selected time',
  'workout.err.openClientWorkoutNoHandler': 'Can’t open client workout (no handler)',
  'workout.err.openClientWorkout': 'Couldn’t open client workout',
  'workout.err.groupExerciseTargets': 'Couldn’t resolve participant workouts to add exercise',
  'workout.toast.exerciseAddedPartial': 'Not added for all participants: {ok}/{total}',
  'workout.toast.exerciseAddedAll': 'Exercise added for all participants ({n})',
  'workout.alert.pickExerciseName': 'Choose or enter an exercise name',
  'workout.alert.setRepsInvalid': 'Set {n}: Enter valid reps (whole numbers only)',
  'workout.alert.setWeightInvalid': 'Set {n}: Enter a valid weight (decimal with . or ,), or leave empty',
  'workout.success.exerciseAdded': 'Exercise added!',
  'workout.err.exerciseAdd': 'Error adding exercise',
  'workout.alert.planNoExercises': 'This plan has no exercises',
  'workout.err.participantWorkoutsPlan': 'Couldn’t resolve participant workouts to add plan',
  'workout.success.planExercisesAdded': 'Added {n} exercises from plan “{name}”',
  'workout.err.planExercisesAdd': 'Error adding exercises from plan',
  'workout.alert.planExercisesAllDuplicate': 'All plan exercises are already in this workout',
  'workout.success.planExercisesAddedCount': 'Added {n} exercises from plan “{name}”',
  'workout.alert.planExercisesAddFail': 'Couldn’t add exercises from plan. Check connection and try again.',
  'workout.alert.planExercisesAllDup2': 'All plan exercises were already added.',
  'workout.err.unknown': 'Unknown error',
  'workout.err.planExercisesWithMsg': 'Error adding exercises from plan: {msg}',
  'workout.confirm.replacePlanExercises': 'Replace all exercises with the selected plan?',
  'workout.err.deleteExistingExercises': 'Error removing existing exercises',
  'workout.success.addedNExercises': 'Added {n} exercises',
  'workout.err.addExercisesBulk': 'Error adding exercises',
  'workout.alert.enterExerciseName': 'Enter exercise name',
  'workout.alert.duplicateExerciseInWorkout': 'An exercise with this name already exists in this workout',
  'workout.success.exerciseUpdated': 'Exercise updated!',
  'workout.err.exerciseUpdate': 'Error updating exercise',
  'workout.err.exerciseDelete': 'Error deleting exercise',
  'workout.err.cancelSeriesNoClient': 'Can’t cancel series: workout has no client',
  'workout.toast.cancelledN': 'Cancelled {n} workouts',
  'workout.toast.workoutCancelled': 'Workout cancelled',
  'workout.err.cancelFailedN': 'Couldn’t cancel {n} workouts',
  'workout.err.cancelNoConfirm': 'Couldn’t cancel workout — server response unclear.',
  'workout.err.cancelWorkout': 'Error cancelling workout',
  'workout.err.withMessage': 'Error: {msg}',
  'workout.err.markSkipped': 'Couldn’t mark as skipped',
  'workout.err.skipMark': 'Error marking as skipped',
  'workout.err.restoreWorkout': 'Error restoring workout',
  'workout.success.commentSaved': 'Comment saved',
  'workout.success.commentRemoved': 'Comment removed',
  'workout.err.commentSave': 'Error saving comment',
  'workout.err.locationUpdate': 'Couldn’t update location',
  'workout.err.locationDelete': 'Error removing location',
  'workout.err.commentDelete': 'Error deleting comment',
  'workout.alert.fillDateTime': 'Fill in date and time',
  'workout.err.transferNoConfirm': 'Couldn’t reschedule — server response unclear.',
  'workout.alert.timeBusy': 'This time is taken. Conflicts: {clients}',
  'workout.alert.otherWorkouts': 'other workouts',
  'workout.alert.sameClientConflict': 'This client already has a workout at this time',
  'workout.err.transferHttp': 'Error rescheduling workout: {status}',
  'workout.err.transferNetwork': 'Network error while rescheduling. Check your connection.',

  'workout.detail.meetingDetails': 'Session details',
  'workout.detail.badgeTransferred': 'Moved',
  'workout.detail.badgeSkipped': 'Skipped',
  'workout.detail.editingTitle': 'Edit',
  'workout.title.pickClient': 'Choose client',
  'workout.title.openClientProfile': 'Open client profile',
  'workout.field.dateTime': 'Date & time',
  'workout.editDateTimeTitle': 'Edit date & time',
  'workout.location.gymNameLabel': 'Gym name *',
  'workout.location.gymNamePh': 'Enter gym name',
  'workout.location.gymAddressLabel': 'Address',
  'workout.location.gymAddressPh': 'Enter address',
  'workout.location.notSetOption': 'Not set',
  'workout.location.addNewGym': '+ Add new gym',
  'workout.location.sectionTitle': 'Location',
  'workout.location.pinOnline': '📍 Online',
  'workout.editLocationTitle': 'Edit location',
  'workout.removeLocationTitle': 'Remove location',
  'workout.removeLocationDesc': 'Remove this workout’s location? This can’t be undone.',
  'workout.addLocationTitle': 'Add location',
  'workout.comment.fullLabel': 'Comment for this workout',
  'workout.comment.shortLabel': 'Comment',
  'workout.editCommentTitle': 'Edit comment',
  'workout.deleteCommentTitle': 'Delete comment',
  'workout.deleteCommentDesc': 'Delete this comment? This can’t be undone.',
  'workout.commentPlaceholder': 'Write a comment…',
  'workout.previousWorkout': 'Previous workout',
  'workout.prevWorkoutNavTitle': 'Earlier completed workout',
  'workout.nextWorkoutNavTitle': 'Later completed workout',
  'workout.exerciseHistoryTitle': 'Exercise history',
  'workout.lastSession': 'Last session',
  'workout.workingWeight': 'Working weight',
  'workout.noHistoryData': 'No data',
  'workout.duplicateExerciseTitle': 'Exercise already added',
  'workout.duplicateExerciseDesc': '“{name}” is already in this workout.',
  'workout.setsLabel': 'Sets',
  'workout.noSetsTitle': 'No sets yet',
  'workout.noSetsHint': 'Add the first set to get started',
  'workout.addFirstSet': 'Add first set',
  'workout.focusRepsTitle': 'Focus reps field',
  'workout.focusWeightTitle': 'Focus weight field',
  'workout.weightInputShort': 'Weight',
  'workout.addAnotherSet': 'Add another set',
  'workout.form.editExercise': 'Edit exercise',
  'workout.form.addExercise': 'Add exercise',
  'workout.exerciseNameLabel': 'Exercise name',
  'workout.tapToPickExercise': 'Tap to choose exercise',
  'workout.searchExercisesShort': 'Search exercises…',
  'workout.historyGroupOnly': 'History is only available for individual workouts',
  'workout.historyNoClient': 'No client on workout — can’t show history',
  'workout.setLine': 'Set {n}: {reps} reps',
  'workout.setWeightPart': ' × {w} kg',
  'workout.noPrevWorkoutData': 'No data for the previous session',
  'workout.exercisesHeading': 'Exercises',
  'workout.planLabel': 'Plan:',
  'workout.unknownPlan': 'Unknown plan',
  'workout.replacePlan': 'Replace plan',
  'workout.replaceShort': 'Replace',
  'workout.addExerciseFull': 'Add exercise',
  'workout.addPlan': 'Add plan',
  'workout.planShort': 'Plan',
  'workout.or': 'or',
  'workout.addReadyMadePlan': 'Add saved plan',
  'workout.pickTrainingPlan': 'Choose training plan',
  'workout.noPlansAvailable': 'No plans available',
  'workout.noExercisesInPlanCard': 'No exercises',
  'workout.noExercises': 'No exercises',
  'workout.editExerciseTitle': 'Edit exercise',
  'workout.deleteExerciseTitle': 'Delete exercise',
  'workout.deleteExerciseConfirmTitle': 'Are you sure?',
  'workout.deleteExerciseConfirmDesc': 'This can’t be undone. The exercise will be removed from this workout.',
  'workout.workingWeightColon': 'Working weight:',
  'workout.workingWeightGroupAlert': 'Working weight can only be updated for individual workouts with a client',
  'workout.updateWorkingWeightTitle': 'Update working weight',
  'workout.updateWeightBtn': 'Update weight',
  'workout.workingWeightKgLabel': 'Working weight (kg)',
  'workout.weightExamplePh': 'e.g. 40',
  'workout.err.noWorkoutClient': 'Workout has no client',
  'workout.err.workingWeightUpdate': 'Error updating working weight',
  'workout.restoreSession': 'Restore session',
  'workout.movedSession': 'Workout was moved',
  'workout.cancelSession': 'Cancel',
  'workout.markSkipBtn': 'Mark as skipped',
  'workout.markDoneBtn': 'Mark as done',
  'workout.markDoneTitle': 'Mark as done',
  'workout.markDoneDesc': 'This workout will be marked as completed.',
  'workout.toast.markedDone': 'Workout marked as done',
  'workout.statusMenuAria': 'Change workout status',
  'workout.err.statusUpdate': 'Couldn’t update workout status',
  'workout.rescheduleTitle': 'Reschedule',
  'workout.rescheduleMoving': 'Moving…',
  'workout.rescheduleValidating': 'Checking…',
  'workout.rescheduleSubmit': 'Reschedule',
  'workout.rescheduleHint': 'Pick a new date and time',
  'workout.conflictTitle': 'Couldn’t create workout',
  'workout.conflictTimeTaken': 'That time is already booked.',
  'workout.conflictingListTitle': 'Conflicting workouts:',
  'workout.clientNotSpecified': 'Client not set',
  'workout.sameSlotTitle': 'Choose a new time',
  'workout.sameSlotDesc': 'Date and time match the current workout. Pick another slot to reschedule.',
  'workout.newDateLabel': 'New date *',
  'workout.startTimeLabel': 'Start time *',
  'workout.endTimeLabel': 'End time',
  'workout.endTimePh': 'Same as original',
  'workout.durationHint': 'Changing start time keeps the same duration as this workout',
  'workout.exerciseConfirmTitle': 'Add new exercise',
  'workout.exerciseConfirmDesc': '“{name}” isn’t in your dictionary. Add it to your exercise list?',
  'workout.muscleGroupLabel': 'Muscle group',
  'workout.muscleGroupPh': 'Select muscle group',
  'workout.dictTrainerNote': 'The exercise will be added to this trainer’s dictionary',
  'workout.pickClientHeader': 'Choose client',
  'workout.openingClientWorkout': 'Opening workout…',
  'workout.willOpenClientWorkout': 'Opens the selected client’s workout',
  'workout.restoreTitle': 'Restore workout',
  'workout.restoreDesc': 'The workout will be restored to Scheduled.',
  'workout.restoring': 'Restoring…',
  'workout.restore': 'Restore',
  'workout.cancelWorkoutTitle': 'Cancel workout',
  'workout.cancelThisWorkout': 'Cancel this workout',
  'workout.cancelFutureWorkouts': 'Cancel this and all following',
  'workout.cancelling': 'Cancelling…',
  'workout.back': 'Back',
  'workout.skipTitle': 'Mark as skipped',
  'workout.skipDesc': 'Mark this workout as skipped? It will be deducted like a completed session.',
  'workout.markingSkip': 'Marking…',
  'workout.addToDictButton': 'Add “{name}”',
  'workout.conflictOverlapFallback': 'This time overlaps with other workouts',
};
